<template lang="pug">
  .form
    .columns.has-text-left
      .column.is-2
        span 
        b Solicitado:
        br
        span.tag.is-black
          | {{ descripcion }}
        br
      .column.is-3
        .field
          label.label Articulo Adquirido
          .control
            typeahead(:options="baseArticulos" :optionSelect="itemSelect" :tema="typeTipos" v-model="itemSelect" :desahabilitar="isDisabled")
      .column.is-2
        .field
          label.label Unidad de Medida
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="unidadM" :disabled='isDisabled')
                option(value="1") Pieza(s)
                option(value="2") Caja(2)
                option(value="3") Estuche(s)
                option(value="4") Juego(s)
                option(value="5") Kit(s)
                option(value="6") Paquete(s)
                option(value="7") Kgr(s)
                option(value="8") Metro(s)
                option(value="9") Galón(es)
                option(value="10") Litro(s)
                option(value="11") Servicio(s)

      .column.is-1
        .field
          label.label Cantidad
          .control
            input.input.is-primary(
              type='number', 
              placeholder='1',
              min='0'
              :max="item.cantidad"
              v-model="cantidad"
              :disabled='isDisabled'
            )
      .column.is-2
        .field
          label.label Precio Unit.
          .control
            input.input.is-primary(
              type='text', 
              placeholder='0.00',
              v-model="precioUnit",
              :disabled='isDisabled'
            )
      .column.is-1(v-show="precioUnit")
        b Importe:
        br
        span.tag.is-black.is-bottom
          | {{ importe }}
      .column.is-1
        a.button.is-black.is-rounded.is-vcentered(@click='checkForm' v-show='statusForm ==0')
          i.fas.fa-save
        a.button.is-warning.is-rounded.is-vcentered(@click='editarForm' v-show='statusForm==1')
          i.fas.fa-pen
        a.button.is-success.is-rounded.is-small.is-vcentered(@click='updateForm' v-show='statusForm==2')
          i.fas.fa-sync-alt
        a.button.is-light.is-rounded.is-small.is-vcentered(@click='cancelEditarForm' v-show='statusForm==2')
          i.fas.fa-ban
    .columns(v-show="Object.keys(datosFaltantes).length > 0")
      .column.is-12
        .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
</template>

<script>
  import typeahead from '../../inventario_Componentes/Typeahead'
  export default {
    name: 'FormDesglose',
    components: { typeahead },
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      baseArticulos: {
        type: Array,
        default: []
      },
      index: {
        type: Number,
        default: 0
      },
      itemsRequisicion: {
        type: Array,
        default: () => []
      }
      
    },
    data() {
      return {
        descripcion: null,
        marca: null,
        modelo: null,
        cantidad: null,
        unidadM: null,
        precioUnit: null,
        importe: null,
        baseArtSel: {},
        typeTipos: 'tipos',
        isDisabled: false,
        itemSelect: {},
        datosFaltantes: [],
        statusForm: 0,
        dataItem: {}
      }
    },
    watch: {
      precioUnit() {
        this.importe = parseFloat(this.precioUnit * this.cantidad).toFixed(2)
      },
      statusForm () {
        switch (this.statusForm) {
          case 0:
            this.isDisabled = false
            break
          case 1:
            this.isDisabled = true
            break
          case 2:
            this.isDisabled = false
            break
        
          default:
            break
        }
      }
      
    },
    methods: {
      iniciarComponente () {
        this.rellenarData()
      },
      checkForm () {
        if (Object.keys(this.itemSelect).length > 0 && this.unidadM && this.cantidad && this.precioUnit) {
          this.saveItem()
        } else {
          if (Object.keys(this.itemSelect).length == 0) {
            this.datosFaltantes.push('Debe seleccionar el artículo adquirido.')
          }
          if (!this.unidadM) {
            this.datosFaltantes.push('La unidad de Medida es requerida.')
          }

          if (!this.cantidad) {
            this.datosFaltantes.push('La cantidad de Medida es requerida.')
          }

          if (!this.precioUnit) {
            this.datosFaltantes.push('El precio unitario es requerido.')
          }
        }
      },
      saveItem() {
        let idItem = 0
        if (Number.isInteger(this.item.id)) {
          idItem = this.item.id
        } else {
          const res = this.item.id.substr(2, this.item.id.length)
          idItem = parseInt(res)
        }

        let myObj = {
          id: idItem,
          index: parseInt(this.index),
          id_equipo: parseInt(this.itemSelect.id),
          cantidad: parseInt(this.cantidad),
          marca: this.itemSelect.marca,
          modelo: this.itemSelect.modelo,
          categoria: this.itemSelect.categoria,
          subcategoria: this.itemSelect.subcategoria,
          id_cat: this.itemSelect.id_cat,
          id_subcat: this.itemSelect.id_subcat,
          unidadM: parseInt(this.unidadM),
          precioUnit: Number(this.precioUnit),
          importe: Number(this.importe),
          tipo: this.item.tipo

        }
        console.log(myObj)
        this.$emit('itemSaved', myObj)
        this.statusForm = 1
      },
      editarForm () {
        this.statusForm = 2
      },
      updateForm () {
        let idItem = 0
        if (this.item.id.substr(0,2) === 's-' ) {
          console.log('string here 🖊🖊🖊🖊') 
          const res = this.item.id.substr(0, this.item.id.length)
          idItem = parseInt(res)
        } else {
          console.log('string here 🌚🌚🌚🌚') 
          idItem = parseInt(this.item.id)
        }

        let myObj = {
          id_ticket: parseInt(this.item.id),
          index: parseInt(this.index),
          id_equipo: this.itemSelect.id,
          cantidad: parseInt(this.cantidad),
          marca: this.itemSelect.marca,
          modelo: this.itemSelect.modelo,
          categoria: this.itemSelect.categoria,
          subcategoria: this.itemSelect.subcategoria,
          id_cat: this.itemSelect.id_cat,
          id_subcat: this.itemSelect.id_subcat,
          unidadM: parseInt(this.unidadM),
          precioUnit: Number(this.precioUnit),
          importe: Number(this.importe),
          tipo: this.item.tipo
        }
        this.$emit('itemUpdate', myObj)
        this.statusForm = 1
      },
      cancelEditarForm () {
        this.statusForm = 1
      },
      rellenarData () {

        if (this.index + 1 > this.itemsRequisicion.length) {
          return
        }
        this.itemSelect = this.baseArticulos.find( item => item.id === this.itemsRequisicion[this.index].id_baseArticulo)
        this.cantidad = this.itemsRequisicion[this.index].cantidad
        this.unidadM = this.itemsRequisicion[this.index].unidadMedida
        this.precioUnit = this.itemsRequisicion[this.index].precioUnitario
        this.importe = this.itemsRequisicion[this.index].importe
      }
    },
    created () {
      this.descripcion = `${this.item.equipo}`
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>
  span.tag.is-dark.is-bottom {
    margin-top: 15px;
  }
  a.button.is-black.is-rounded.is-vcentered {
    margin-top: 32px;
  }
</style>


// WEBPACK FOOTER //
// src/components/cotizaciones_Componentes/componentes/FormDesglose.vue